import React, {forwardRef} from 'react';
import CheckmarxSCAMappingForm from './CheckmarxSCAMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import { Alert } from 'antd';

function CheckmarxSCACredentialForm(props, ref){
    const fields = [{
        name: "account",
        label: "Account",
        required: true,
        rules:[urlRegexValidator],
    },{
        name: "username",
        label: "Username",
        required: true
    }, {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true
    },
    {
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
    }]
    return(
        <GenericPullCredentialsForm
        {...props}
        ref={ref}
        fields={fields}
        MappingForm={CheckmarxSCAMappingForm}
        />
    )
};

export default forwardRef(CheckmarxSCACredentialForm)